module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.23309",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.4771",
      "conversations-error-reporting": "static-1.6047",
      "conversations-internal-pub-sub": "static-1.12827",
      "conversations-internal-schema": "static-1.9897",
      "conversations-message-history": "static-1.8137",
      "conversations-test-sdk": "static-1.7656",
      "conversations-visitor-experience-components": "static-1.16671",
      "head-dlb": "static-1.2284",
      "hs-promise-utils": "static-1.2623",
      "hs-test-utils": "static-1.5153",
      "hubspot-dlb": "static-1.1772",
      "HubStyleTokens": "static-2.8702",
      "I18n": "static-7.1276",
      "jasmine-immutable": "static-1.339",
      "jasmine-runner": "static-1.3517",
      "quartz": "static-1.3706",
      "react-aria": "static-1.30",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.17",
      "transmute": "static-2.29",
      "urlinator": "static-1.1842",
      "viral-links-lib": "static-1.3806",
      "visitor-ui-component-library": "static-1.3528",
      "webpack-env": "static-1.41",
      "ably-hubspot-js": "static-2.1731",
      "atom": "static-1.2642",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.1962",
      "conversations-infrastructure": "static-1.6178",
      "conversations-prop-types": "static-1.4731",
      "conversations-visibility-tools": "static-1.2961",
      "conversations-visitor-message-history": "static-1.15408",
      "cssUtils": "static-1.318",
      "enviro": "static-4.266",
      "flux-actions": "static-1.244",
      "hs-lodash": "static-4.9",
      "hub-http": "static-1.2732",
      "hubspot-url-utils": "static-1.1402",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.6084",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.245",
      "raven": "static-3.2864",
      "react": "static-7.133",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.13558",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.2938",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.6",
      "sanitize-text": "static-1.5407",
      "signup-constants": "static-1.13296",
      "styled-components": "static-2.40",
      "StyleGuideUI": "static-3.425",
      "usage-tracker": "static-1.4625",
      "usage-tracker-core": "static-1.4475",
      "usage-tracker-multi": "static-1.3039",
      "usage-tracker-public": "static-1.4436",
      "visitor-ui-component-library-icons": "static-1.3339",
      "hs-promise-rejection-tracking": "static-1.2603",
      "raven-hubspot": "static-1.3171",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.785",
      "moment": "static-3.26",
      "react-immutable-proptypes": "static-2.8",
      "UIComponents": "static-3.5652",
      "conversations-skeleton-state": "static-1.4585",
      "cv-backend-services": "static-1.786",
      "icons": "static-2.584",
      "react-input-autosize": "static-2.17",
      "ui-addon-avatars": "static-2.6741",
      "ui-images": "static-2.753",
      "permission-components": "static-1.2526",
      "react-virtualized": "static-2.65",
      "HeadJS": "static-2.502",
      "foundations-components": "static-1.3681",
      "foundations-theming": "static-1.1096",
      "framer-motion": "static-1.28",
      "hs-test-utils-bend-plugin": "static-1.264",
      "hub-http-janus": "static-1.569",
      "hub-http-rxjs": "static-1.534",
      "msw": "static-1.39",
      "redux-mock-store": "static-1.8",
      "testing-library": "static-1.111",
      "i18n-data": "static-1.186",
      "moment-timezone": "static-5.17",
      "jasmine": "static-4.1530",
      "browserslist-config-hubspot": "static-1.138",
      "quartz-core-utils": "static-1.573",
      "foundations-assets": "static-1.1991",
      "signup-ui-url-generator": "static-2.5135",
      "HubStyle": "static-2.9012",
      "sassPrefix": "static-1.119",
      "csstype": "static-1.8",
      "history": "static-4.15",
      "usage-tracker-anonymous": "static-1.3042",
      "hs-story-utils": "static-1.6105",
      "ts-schema": "static-1.1709",
      "hubspotter-http": "static-1.2286",
      "floating-ui": "static-1.18",
      "tanstack-table": "static-1.10",
      "ui-fonts": "static-1.326",
      "foundations-theming-base": "static-1.81",
      "rxjs": "static-5.10"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.23309",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.4771",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.6047",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.12827",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.9897",
      "conversations-message-history": "/conversations-message-history/static-1.8137",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.7656",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.16671",
      "head-dlb": "/head-dlb/static-1.2284",
      "hs-promise-utils": "/hs-promise-utils/static-1.2623",
      "hs-test-utils": "/hs-test-utils/static-1.5153",
      "hubspot-dlb": "/hubspot-dlb/static-1.1772",
      "HubStyleTokens": "/HubStyleTokens/static-2.8702",
      "I18n": "/I18n/static-7.1276",
      "jasmine-immutable": "/jasmine-immutable/static-1.339",
      "jasmine-runner": "/jasmine-runner/static-1.3517",
      "quartz": "/quartz/static-1.3706",
      "react-aria": "/react-aria/static-1.30",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.17",
      "transmute": "/transmute/static-2.29",
      "urlinator": "/urlinator/static-1.1842",
      "viral-links-lib": "/viral-links-lib/static-1.3806",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.3528",
      "webpack-env": "/webpack-env/static-1.41",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.1731",
      "atom": "/atom/static-1.2642",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.1962",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.6178",
      "conversations-prop-types": "/conversations-prop-types/static-1.4731",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.2961",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.15408",
      "cssUtils": "/cssUtils/static-1.318",
      "enviro": "/enviro/static-4.266",
      "flux-actions": "/flux-actions/static-1.244",
      "hs-lodash": "/hs-lodash/static-4.9",
      "hub-http": "/hub-http/static-1.2732",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.1402",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.6084",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.245",
      "raven": "/raven/static-3.2864",
      "react": "/react/static-7.133",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.13558",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.2938",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.6",
      "sanitize-text": "/sanitize-text/static-1.5407",
      "signup-constants": "/signup-constants/static-1.13296",
      "styled-components": "/styled-components/static-2.40",
      "StyleGuideUI": "/StyleGuideUI/static-3.425",
      "usage-tracker": "/usage-tracker/static-1.4625",
      "usage-tracker-core": "/usage-tracker-core/static-1.4475",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.3039",
      "usage-tracker-public": "/usage-tracker-public/static-1.4436",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.3339",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.2603",
      "raven-hubspot": "/raven-hubspot/static-1.3171",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.785",
      "moment": "/moment/static-3.26",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "UIComponents": "/UIComponents/static-3.5652",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.4585",
      "cv-backend-services": "/cv-backend-services/static-1.786",
      "icons": "/icons/static-2.584",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.6741",
      "ui-images": "/ui-images/static-2.753",
      "permission-components": "/permission-components/static-1.2526",
      "react-virtualized": "/react-virtualized/static-2.65",
      "HeadJS": "/HeadJS/static-2.502",
      "foundations-components": "/foundations-components/static-1.3681",
      "foundations-theming": "/foundations-theming/static-1.1096",
      "framer-motion": "/framer-motion/static-1.28",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.264",
      "hub-http-janus": "/hub-http-janus/static-1.569",
      "hub-http-rxjs": "/hub-http-rxjs/static-1.534",
      "msw": "/msw/static-1.39",
      "redux-mock-store": "/redux-mock-store/static-1.8",
      "testing-library": "/testing-library/static-1.111",
      "i18n-data": "/i18n-data/static-1.186",
      "moment-timezone": "/moment-timezone/static-5.17",
      "jasmine": "/jasmine/static-4.1530",
      "browserslist-config-hubspot": "/browserslist-config-hubspot/static-1.138",
      "quartz-core-utils": "/quartz-core-utils/static-1.573",
      "foundations-assets": "/foundations-assets/static-1.1991",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.5135",
      "HubStyle": "/HubStyle/static-2.9012",
      "sassPrefix": "/sassPrefix/static-1.119",
      "csstype": "/csstype/static-1.8",
      "history": "/history/static-4.15",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.3042",
      "hs-story-utils": "/hs-story-utils/static-1.6105",
      "ts-schema": "/ts-schema/static-1.1709",
      "hubspotter-http": "/hubspotter-http/static-1.2286",
      "floating-ui": "/floating-ui/static-1.18",
      "tanstack-table": "/tanstack-table/static-1.10",
      "ui-fonts": "/ui-fonts/static-1.326",
      "foundations-theming-base": "/foundations-theming-base/static-1.81",
      "rxjs": "/rxjs/static-5.10"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};